// CommentModal (Phase 29) — the two positioned comment slots for one company row.
import Modal from '@/components/ui/Modal/Modal';
import CompanyCommentSlots from './CompanyCommentSlots';

export interface CommentModalProps {
  resultId: string;
  /** The company row the modal is editing; null keeps the modal closed. */
  companyName: string | null;
  onClose: () => void;
  /** Preview tab / shared-result viewing: comments are visible but not editable. */
  readOnly?: boolean;
}

export default function CommentModal({
  resultId,
  companyName,
  onClose,
  readOnly = false,
}: CommentModalProps) {
  const open = companyName !== null;
  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose} title={`Comments — ${companyName}`} size="md">
      <CompanyCommentSlots resultId={resultId} companyName={companyName} readOnly={readOnly} />
    </Modal>
  );
}
